<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<nav aria-label="Main navigation">
  <fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <div class="flex items-center w-full p-4 pl-6">
        <!-- Logo -->
        <div class="flex items-center justify-center">
          <img class="w-8" src="assets/images/logo/eprint-logo.svg" alt="Logo image">
        </div>
        <!-- Components -->
        <!-- <div class="flex items-center ml-auto">
        <app-languages></app-languages>
        <user [showAvatar]="false"></user>
      </div> -->
    </div>
    <!-- User -->
    <div class="flex flex-col items-center w-full p-4">
      <div class="relative w-24 h-24">
        <mat-icon
          class="icon-size-24"
        [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
      </div>
      <div class="flex flex-col items-center justify-center w-full mt-6">
        <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
          {{firstName}} {{lastName}}
        </div>
        <div class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
          {{userEmail}}
        </div>
      </div>
    </div>
  </ng-container>
</fuse-vertical-navigation>
</nav>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 max-h-[100%] overflow-auto" id="container">
  <!-- Header -->
  <header aria-label="Page header" class="relative flex flex-0 items-center w-full h-12 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <!-- Navigation toggle button -->
    <button mat-icon-button id="classyCmp_toggleNavBtn" aria-label="Toggle navigation menu" (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
    <app-breadcrumb [breadCrumbConfig]="breadCrumbConfig"></app-breadcrumb>
  </header>
  <!-- Content -->
  <div aria-label="Main content" class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <footer aria-label="Page footer" class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
    <span class="font-medium text-secondary">ePRINTit &copy; {{currentYear}}</span>
  </footer>

</div>
